import React, {useState, useEffect, useRef} from 'react';
import styled from "styled-components";
import {CountdownCircleTimer} from 'react-countdown-circle-timer'
import {HandleLoginHeader} from "./login";
import {formatPhoneNumber, toEnglishNumber} from "@helpers/numbers";
import ButtonBase from "@atoms/button.base";
import ButtonTransparent from "@atoms/button.transparent";
import ConvertPixelToRem from "@helpers/convert.rem";
import {isEmpty} from "@helpers/helpers";
import Captcha from "./captcha";
import CircleLoading from "@molecules/lotties/circle_loading";

function Code({level, show, setShow, fields, setFields, handleVerificationCode, userExist, handleRegister, handleContinue, loginByCode, handleChange, handleForceRefreshCaptcha}) {
    const defaultTime = 60;
    const [code, setCode] = useState([]);
    const [time, setTime] = useState(defaultTime);
    const [resend, setResend] = useState(0);

    const code_field_count = 4;
    let code_refs = [];
    for (let i = 0; i < code_field_count; i++) {
        code_refs.push(useRef(''));
    }

    useEffect(() => {
        if (code.length === 0 && process.browser && code_refs[0].current && code_refs[0].current !== "") {
            code_refs[0].current.focus();
        }

        const handleUserKeyPress = (event) => {
            const {key, keyCode} = event;
            if (show && keyCode === 13) {
                if (level.code) {
                    handleCodes();
                }
            }
        };

        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    });

    const handleKeyUp = (event) => {
        const index = parseInt(event.target.dataset.id);
        let values = Object.assign([], code);

        if (event.key === "Backspace") {
            const back = code_refs[index - 1];

            if (!isEmpty(back) && !isEmpty(back.current)) {
                back.current.focus();
                back.current.select();

                values[index] = '';
                setCode(values);
            }
        }
    };

    const handleCodeChange = (event) => {
        const index = parseInt(event.target.dataset.id);
        let value = toEnglishNumber(event.target.value);
        const number_regexp = /^[0-9\b]+$/;
        if (!isEmpty(value) && !number_regexp.test(value)) {
            return;
        }

        const name = event.target.name;

        let next;
        let values = Object.assign([], code);

        if (value === '') {
            values[index] = '';
            setCode(values);
            return;
        }


        if (value.length > 1) {
            let newIndex = index + 1;
            if (newIndex >= code_field_count) {
                newIndex = code_field_count - 1;
            }

            next = code_refs[newIndex];

            const split = value.split('');

            values[index] = split[0];
            setCode(values)
        } else {
            next = code_refs[index + 1];
            values[index] = value;
            setCode(values);
        }

        if (next) {
            next.current.focus();
            next.current.select();
        }

    };

    const handleCodes = () => {
        const value = code.join('');

        if (code.length === 4) {
            setFields(state => ({
                ...state,
                ['code']: {value: value, error: '', loading: true},
            }));
            //console.log(userExist)
            if (userExist) {
                loginByCode(value);
            } else {
                handleRegister('', false, true, value);
            }
        } else {
            setFields(state => ({
                ...state,
                ['code']: {value: value, error: 'کد تایید 4 رقمی رو وارد کنید.', loading: false},
            }));
        }
    };

    useEffect(() => {
        const value = fields.code.value;
        let old_code = [];
        if (!isEmpty(value)) {
            old_code = value.split('');
        }
        setCode(old_code);
    }, [fields.code.value]);

    const handleResendCode = () => {
        handleVerificationCode('code', true);
        setTime(defaultTime);
        setResend(resend + 1);
    };

    const renderTime = ({remainingTime}) => {
        return (
            <div className="timer">
                <div className="value">{remainingTime}</div>
            </div>
        );
    };

    useEffect(() => {
        if (level.code) {
            setTime(defaultTime);
        }

        function handleClipboardPaste(e) {
            // if the target is a text input
            if (e.target.type === "tel" && e.target.name === 'login_code') {
                let data = e.clipboardData.getData('Text');

                data = data.split('');
                setCode(data);
            }
        }

        window.addEventListener('paste', handleClipboardPaste);
        return () => {
            window.removeEventListener("paste", handleClipboardPaste);
        };
    }, [level.code]);

    return (
        <Container show={level.code}>
            <HandleLoginHeader title={"تایید " + (!isEmpty(fields.mobile.value) ? 'موبایل' : 'ایمیل')} close={() => setShow(false)} back={() => handleContinue('mobile')}/>

            <p className="mt-24 text-center">کد ارسال شده به <span>{formatPhoneNumber((!isEmpty(fields.mobile.value) ? fields.mobile.value : fields.email.value))}</span> رو وارد کنید.</p>

            <div className="form-group mb-0 is-invalid-no-bg">
                <div className="row align-items-center justify-content-between mt-24 ltr">
                    <div className="col-3">
                        <input name="login_code" type="tel" className={"code-inputs form-control text-center p-0 d-flex align-items-center justify-content-center " + (!isEmpty(fields.code.error) ? 'is-invalid' : '')} data-id={0} ref={code_refs[0]} value={(code[0] ? code[0] : '')} onChange={(e) => handleCodeChange(e)} onKeyUp={handleKeyUp} pattern="[0-9]*"/>
                    </div>
                    <div className="col-3">
                        <input name="login_code" type="tel" className={"code-inputs form-control text-center p-0 d-flex align-items-center justify-content-center " + (!isEmpty(fields.code.error) ? 'is-invalid' : '')} data-id={1} ref={code_refs[1]} value={(code[1] ? code[1] : '')} onChange={(e) => handleCodeChange(e)} onKeyUp={handleKeyUp} pattern="[0-9]*"/>
                    </div>
                    <div className="col-3">
                        <input name="login_code" type="tel" className={"code-inputs form-control text-center p-0 d-flex align-items-center justify-content-center " + (!isEmpty(fields.code.error) ? 'is-invalid' : '')} data-id={2} ref={code_refs[2]} value={(code[2] ? code[2] : '')} onChange={(e) => handleCodeChange(e)} onKeyUp={handleKeyUp} pattern="[0-9]*"/>
                    </div>
                    <div className="col-3">
                        <input name="login_code" type="tel" className={"code-inputs form-control text-center p-0 d-flex align-items-center justify-content-center " + (!isEmpty(fields.code.error) ? 'is-invalid' : '')} data-id={3} ref={code_refs[3]} value={(code[3] ? code[3] : '')} onChange={(e) => handleCodeChange(e)} onKeyUp={handleKeyUp} pattern="[0-9]*"/>
                    </div>
                </div>
                {
                    !isEmpty(fields.code.error) ?
                        <div className="invalid-feedback d-block">
                            {fields.code.error}
                        </div>
                        : ''
                }
            </div>

            {
                (level.code && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                    <Captcha
                        handleChange={handleChange}
                        token={fields.captcha.token}
                        fields={fields}
                        setFields={setFields}
                        handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                        className="mt-24"
                    />
                    : ''
            }

            <ButtonBase onClick={() => handleCodes()} color="secondary" block className={"mt-16 "} disabled={fields.code.loading}>
                {
                    (fields.code.loading) ?
                        <CircleLoading width={24} height={24}/>
                        :
                        'تایید'
                }
            </ButtonBase>

            <div className="mt-40 mb-8 text-center">

                {
                    (time > 0 && level.code) ?
                        <div className="d-flex align-items-center justify-content-center">
                            <CountdownCircleTimer
                                isPlaying
                                size={32}
                                strokeWidth={1.5}
                                duration={time}
                                colors="#222222"
                                onComplete={() => setTime(0)}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                            <span className="mr-8">ارسال مجدد کد</span>
                        </div>
                        :
                        <React.Fragment>
                            <span>کد رو دریافت نکردید؟</span>
                            <ButtonTransparent className="mr-8 text-secondary" onClick={() => handleResendCode()}>ارسال مجدد کد</ButtonTransparent>
                        </React.Fragment>
                }

            </div>
        </Container>
    )
}

export default React.memo(Code);

// styles
const Container = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

  input.code-inputs {
    font-size: ${ConvertPixelToRem(24)};
    width: 100%;
  }
`;
